import * as React from 'react';

// tslint:disable-next-line: no-import-side-effect
import 'regenerator-runtime/runtime';

import { init } from './initialize';
import { Main } from './sfc/main';

init('redirect', <Main />);
